"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.UnstyledList = exports.ActionLink = exports.MenuAction = exports.MenuFooter = exports.ProfileIcon = exports.MenuLink = exports.MenuDescription = exports.MenuLabel = exports.MobileMenuItem = exports.MenuMain = exports.MenuTitle = exports.HeaderItem = exports.MenuHeader = exports.MenuBurgerWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _framerMotion = require("framer-motion");

var _AvatarImage = _interopRequireDefault(require("../../AvatarImage"));

var _Link = _interopRequireDefault(require("../../Link"));

var MenuBurgerWrapper = (0, _styled.default)(_framerMotion.motion.div)(function (_ref) {
  var _ref$theme = _ref.theme,
      space = _ref$theme.space,
      colors = _ref$theme.colors,
      showMenu = _ref.showMenu;
  return {
    position: 'fixed',
    top: 0,
    width: '100%',
    height: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    overflow: 'auto',
    overflowScrolling: 'touch',
    WebkitOverflowScrolling: 'touch',
    borderRadius: space.xsmall,
    backgroundColor: colors.white,
    right: showMenu ? 0 : '-100%',
    transition: 'right 0.3s ease-in-out'
  };
});
exports.MenuBurgerWrapper = MenuBurgerWrapper;
var MenuHeader = (0, _styled.default)('div')(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      space = _ref2$theme.space,
      colors = _ref2$theme.colors,
      nav = _ref2$theme.nav;
  return {
    backgroundColor: colors.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: "".concat(space.medium, " 0"),
    borderBottom: "1px solid ".concat(nav.borderColor),
    height: '7rem'
  };
});
exports.MenuHeader = MenuHeader;
var HeaderItem = (0, _styled.default)('div')(function () {
  return {
    minWidth: '4rem',
    width: 'fit-content',
    display: 'block',
    textAlign: 'center'
  };
});
exports.HeaderItem = HeaderItem;
var MenuTitle = (0, _styled.default)('h2')(function (_ref3) {
  var space = _ref3.theme.space;
  return {
    fontWeight: 'bold',
    fontSize: '1.5rem',
    margin: "".concat(space.none, " ").concat(space.xsmall)
  };
});
exports.MenuTitle = MenuTitle;
var MenuMain = (0, _styled.default)('nav')(function () {
  return {
    width: '100%',
    overflow: 'auto',
    overflowScrolling: 'touch',
    WebkitOverflowScrolling: 'touch',
    // Apply different styling for non iOS devices (Safari)
    '@supports not (-webkit-touch-callout: none)': {
      height: 'calc(100vh - 7rem)'
    }
  };
});
exports.MenuMain = MenuMain;
var MobileMenuItem = (0, _styled.default)('div')(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      space = _ref4$theme.space,
      nav = _ref4$theme.nav,
      hasDecription = _ref4.hasDecription;
  return {
    display: hasDecription ? 'block' : 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: "".concat(space.large, " ").concat(space.xsmall, " ").concat(space.large, " ").concat(space.base),
    borderBottom: "1px solid ".concat(nav.borderColor)
  };
});
exports.MobileMenuItem = MobileMenuItem;
var MenuLabel = (0, _styled.default)('p')(function (_ref5) {
  var enhanced = _ref5.enhanced,
      _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      nav = _ref5$theme.nav,
      space = _ref5$theme.space;
  return {
    fontWeight: 'bold',
    fontSize: '1.6rem',
    margin: space.none,
    color: colors.primary,
    borderBottom: enhanced ? "0.2rem solid ".concat(colors[nav.accentColor]) : 'none'
  };
});
exports.MenuLabel = MenuLabel;
var MenuDescription = (0, _styled.default)('p')(function (_ref6) {
  var _ref6$theme = _ref6.theme,
      space = _ref6$theme.space,
      colors = _ref6$theme.colors;
  return {
    fontSize: '1.3rem',
    flexBasis: '95%',
    color: colors.black,
    margin: space.none
  };
});
exports.MenuDescription = MenuDescription;
var MenuLink = (0, _styled.default)(_Link.default)(function (_ref7) {
  var colors = _ref7.theme.colors;
  return {
    color: colors.black,
    border: 'none',
    textDecoration: 'none',
    backgroundColor: colors.none,
    '&:visited': {
      border: 'none',
      textDecoration: 'none',
      color: colors.black,
      backgroundColor: colors.none
    },
    '&:visited > span': {
      border: 'none',
      textDecoration: 'none',
      color: colors.black,
      backgroundColor: colors.none
    }
  };
});
exports.MenuLink = MenuLink;
var ProfileIcon = (0, _styled.default)(_AvatarImage.default)(function (_ref8) {
  var _ref8$theme = _ref8.theme,
      space = _ref8$theme.space,
      colors = _ref8$theme.colors;
  return {
    border: "1px solid ".concat(colors.black),
    marginRight: space.small
  };
});
exports.ProfileIcon = ProfileIcon;
var MenuFooter = (0, _styled.default)('div')(function () {
  return {
    display: 'flex',
    // Apply different styling for non iOS devices (Safari)
    '@supports not (-webkit-touch-callout: none)': {
      position: 'fixed',
      width: '100%',
      bottom: 0
    },
    '& > *': {
      flex: 1
    }
  };
});
exports.MenuFooter = MenuFooter;
var MenuAction = (0, _styled.default)('div')(function (_ref9) {
  var _ref9$theme = _ref9.theme,
      space = _ref9$theme.space,
      colors = _ref9$theme.colors,
      nav = _ref9$theme.nav,
      variant = _ref9.variant;
  return {
    border: 'none',
    padding: space.large,
    fontWeight: 600,
    textAlign: 'center',
    fontSize: '1.6rem',
    color: variant === 'secondary' ? colors.white : colors.black,
    backgroundColor: variant === 'secondary' ? colors.black : colors[nav.accentColor]
  };
});
exports.MenuAction = MenuAction;
var ActionLink = (0, _styled.default)(_Link.default)(function () {
  return {
    color: 'inherit',
    '& > span': {
      borderBottom: 'none'
    }
  };
});
exports.ActionLink = ActionLink;
var UnstyledList = (0, _styled.default)('ul')({
  listStyleType: 'none',
  margin: 0,
  padding: 0,
  display: 'inherit'
});
exports.UnstyledList = UnstyledList;